import React from 'react';
import './Sec1.css';
import Navbar from '../../Navbar/Navbar';
import { Link } from 'react-router-dom';
import bg from '../../../images/sec 1/bg.png';

const Sec1 = () => {
  return (
    <div className='home1 bg-cover bg-center h-screen lg:pb-3' style={{ backgroundImage: `url(${bg})` }}>
      <Navbar />
      <div className='home-sec1 grid grid-cols-1 md:grid-cols-2 px-6 md:px-16 lg:px-24 mb-0 md:mx-9'>
        {/* Left Side: Logo and Text */}
        <div className='Sec1-left w-full mt-6 mx-12 md:mt-0 flex flex-col items-start justify-center'>
          <header className="flex flex-col items-start mb-6">
            <img src="images/logo.png" alt="Logo" className="logo" />
            <h1 className="text-white text-2xl font-bold mt-2">Real Money - Play & Earn Cash</h1>
            <nav>
              <ul>
                {/* <li><Link to="#games">Home</Link></li> */}
              </ul>
            </nav>
          </header>
          <div className='text-white text-lg text-left Sec1-left'>
            <h3 className='text-xl font-bold mb-4' style={{ fontSize: '2rem', marginTop: '10px' }}>Earn While You Play!</h3>
            <p>
              When you play free games on the Real Money App, you can earn real cash and receive gift cards.<br />
              The more you play, the more you earn.
            </p>
            <p>
              With Real Money, you can earn money online, win Free Paytm Cash, Free UPI Cash, and gift cards from Google Play and Flipkart.
            </p>
          </div>
        </div>

        {/* Right Side: Featured Games */}
        <div className='Sec1-right h-full z-20 pt-9'>
          <main>
            <section id="games">
              <h2 style={{ color: 'white' }}>Featured Games</h2>
              <div className="game-container">
                <div className="game-card">
                  <img src="images/realmoney.webp" alt="Game 1" />
                  <h3>Wealth Warriors - Play & Earn!</h3>
                  <p>When you play free games on Real Money App, you can earn real cash and receive gift cards.</p>
                </div>
                <div className="game-card">
                  <img src="images/realmoney2.webp" alt="Game 2" />
                  <h3>Cash Craze - Play & Win Big!</h3>
                  <p>Play games, earn real cash, gift cards, and rewards effortlessly while enjoying thrilling experiences.</p>
                </div>
                <div className="game-card">
                  <img src="images/money3.webp" alt="Game 3" />
                  <h3>Money Mania - Play, Win, Repeat!</h3>
                  <p>When you enjoy free games on the Real Money App, you can win actual cash and earn gift cards.</p>
                </div>
                <div className="game-card">
                  <img src="images/money4.webp" alt="Game 4" />
                  <h3>Treasure Hunt - Find the Gold!</h3>
                  <p>Embark on an exciting adventure to find treasures and earn big rewards while playing for free.</p>
                </div>
              </div>
            </section>
            <div className="get-google-play flex justify-center items-center mt-8 mb-4">
              <div className="text-center">
                <h2 className="text-white mb-4">Get it on Google Play</h2>
                <a href="https://play.google.com/store/apps/details?id=com.realmoneyearninggames.app" target="_blank" rel="noopener noreferrer">
                  <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Get it on Google Play" style={{ width: '200px' }} />
                </a>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}

export default Sec1;
